export default __webpack_public_path__ + "static/media/aww-yeah.680ba5a2.gif";